var _g, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSadUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.46,
    height: 23.45,
    viewBox: "0 0 20.46 23.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sad-user"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.5,11.2h-.2a5.4,5.4,0,1,1,.2,0ZM7.6,5.8a3.78,3.78,0,0,0,3.7,3.8h.3A3.8,3.8,0,0,0,11.4,2,3.86,3.86,0,0,0,7.6,5.8Z",
    transform: "translate(-1.79 -0.4)",
    fill: "{props.color}",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8,22.8a5.23,5.23,0,0,1-2.9-3.6,5.56,5.56,0,0,1,1-4.5,8.48,8.48,0,0,1,10-2.4,1,1,0,0,1,.5,1.1.61.61,0,0,1-.9.5,7.27,7.27,0,0,0-8.5,2,3.36,3.36,0,0,0-.7,3,3.26,3.26,0,0,0,2,2.3,6.54,6.54,0,0,0,4.6.4.89.89,0,0,1,.4,1.7A7.93,7.93,0,0,1,4.8,22.8Z",
    transform: "translate(-1.79 -0.4)",
    fill: "{props.color}"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_20",
    "data-name": "Capa 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2,17.7a5.91,5.91,0,0,1,5.9-5.9,5.9,5.9,0,0,1,0,11.8A5.91,5.91,0,0,1,10.2,17.7Zm.8,0a5.1,5.1,0,1,0,5.1-5.1A5.12,5.12,0,0,0,11,17.7Z",
    transform: "translate(-1.79 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "victima"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.24,17.77a.31.31,0,0,1,0,.11,1,1,0,0,1,0,.12,1.83,1.83,0,0,1-1.8,1.4,1.73,1.73,0,0,1-1.7-1.5,1.89,1.89,0,0,1,1.5-2.1,1.67,1.67,0,0,1,2,1.5v.1a.46.46,0,0,1,0,.09A2,2,0,0,1,20.24,17.77ZM18.5,18.9a1.32,1.32,0,0,0,1.3-1.3,1.42,1.42,0,0,0-1.3-1.4,1.35,1.35,0,0,0-1.3,1.4A1.32,1.32,0,0,0,18.5,18.9Z",
    transform: "translate(-1.79 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8,16c-.1-.2-.1-.3-.2-.5a3.25,3.25,0,0,0,.54-.26,3.93,3.93,0,0,0,.46-.34,2.31,2.31,0,0,0,.44-.38A2.23,2.23,0,0,0,14.4,14a.92.92,0,0,0,.21.17.72.72,0,0,0,.19.13,3.53,3.53,0,0,1-1.7,1.5,2,2,0,0,1,2.5,1.3,2,2,0,0,1-1.1,2.3A1.91,1.91,0,0,1,12.8,16Zm2.4,1.7a1.4,1.4,0,1,0-1.4,1.4A1.43,1.43,0,0,0,15.2,17.7Z",
    transform: "translate(-1.79 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7,20.8l-.1.14a1.4,1.4,0,0,0-.1.16,2,2,0,0,0-2.3,0L15.09,21l-.19-.17A2.4,2.4,0,0,1,17.7,20.8Z",
    transform: "translate(-1.79 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6,15c0,.06,0,.13-.07.2a1.16,1.16,0,0,1-.13.2,3.35,3.35,0,0,1-1.8-1.5.52.52,0,0,1,.4-.2A3,3,0,0,0,19.6,15Z",
    transform: "translate(-1.79 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8,17.5c.2.2.5.3.6.1s.1-.4-.1-.6a.71.71,0,0,1,.8.3A.79.79,0,0,1,18,18.4,1,1,0,0,1,17.8,17.5Zm.8.6a.2.2,0,1,0,.2-.2C18.6,17.9,18.6,18,18.6,18.1Z",
    transform: "translate(-1.79 -0.4)",
    fill: "{props.color}"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1,17.7c.2.2.5.3.6.1s.1-.4-.1-.6a.67.67,0,0,1,.8.3.77.77,0,0,1-.1,1,.84.84,0,0,1-.42.25.85.85,0,0,1-.57-.08,1.67,1.67,0,0,1-.19-.47A1.78,1.78,0,0,1,13.1,17.7Zm1,.8a.2.2,0,1,0-.2-.2A.22.22,0,0,0,14.1,18.5Z",
    transform: "translate(-1.79 -0.4)",
    fill: "{props.color}"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1.79 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-1.79 -0.4)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.53,23.3",
    transform: "translate(-1.79 -0.4)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.63,15.41",
    transform: "translate(-1.79 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadUser);
export default __webpack_public_path__ + "static/media/sad-user.a38389c6e223859612cd3bb63f9f13eb.svg";
export { ForwardRef as ReactComponent };